<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [applicationId]="applicationId"
  [isReadOnly]="true"
></wm-form-activity-input-view>
